(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antes-depois-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      var compares = root.querySelectorAll('[data-izba-compare]');
      compares.forEach(function (compare) {
        if (compare.__izbaBound) return;
        compare.__izbaBound = true;
        var range = compare.querySelector('[data-izba-range]');
        if (!range) return;
        function apply() {
          compare.style.setProperty('--izba-pos', range.value);
        }
        range.addEventListener('input', apply, { passive: true });
        // Keyboard arrows already handled by the native range input.
        apply();
      });
    }

    function init() {
      bind(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-bind when a block/section is (re)loaded in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
      bind(e.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comentarios-sociais"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRail(rail) {
      if (rail.__sfbBound) return;
      rail.__sfbBound = true;
      var wrap = rail.closest('.sfb__wrap') || rail.parentNode;
      if (!wrap) return;
      function mk(dir, sym) {
        var b = document.createElement('button');
        b.className = 'sfb-arrow sfb-arrow--' + dir;
        b.type = 'button';
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
        b.textContent = sym;
        return b;
      }
      var prev = mk('prev', '‹');
      var next = mk('next', '›');
      wrap.appendChild(prev);
      wrap.appendChild(next);
      function step() {
        var c = rail.children[0];
        return c ? c.getBoundingClientRect().width + 14 : 340;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      function upd() {
        prev.disabled = rail.scrollLeft < 8;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      }
      rail.addEventListener('scroll', upd, { passive: true });
      upd();
    }
    function init() { document.querySelectorAll('[data-sfb-rail]').forEach(initRail); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else { init(); }
    document.addEventListener('shopify:section:load', function (e) {
      var r = (e.target || document).querySelector('[data-sfb-rail]');
      if (r) { r.__sfbBound = false; initRail(r); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["por-que-importa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function animateRing(ring, duration) {
      var target = parseFloat(ring.getAttribute('data-target')) || 0;
      var pctEl = ring.querySelector('[data-wim-pct]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !duration) {
        ring.style.setProperty('--p', target);
        if (pctEl) pctEl.textContent = Math.round(target) + '%';
        return;
      }
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var t = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - t, 3);
        var val = target * eased;
        ring.style.setProperty('--p', val);
        if (pctEl) pctEl.textContent = Math.round(val) + '%';
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function initSection(section) {
      if (section.__wimBound) return;
      section.__wimBound = true;
      var animate = section.getAttribute('data-animate') === 'true';
      var duration = parseInt(section.getAttribute('data-duration'), 10) || 0;
      var rings = section.querySelectorAll('[data-wim-ring]');
      if (!animate || !('IntersectionObserver' in window)) {
        rings.forEach(function (r) {
          r.style.setProperty('--p', r.getAttribute('data-target'));
        });
        return;
      }
      // start collapsed
      rings.forEach(function (r) { r.style.setProperty('--p', 0); var p = r.querySelector('[data-wim-pct]'); if (p) p.textContent = '0%'; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            animateRing(e.target, duration);
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.4 });
      rings.forEach(function (r) { io.observe(r); });
    }

    function init() {
      document.querySelectorAll('[data-wim]').forEach(initSection);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = (e.target || document).querySelector('[data-wim]') || (e.target && e.target.matches && e.target.matches('[data-wim]') ? e.target : null);
      if (el) { el.__wimBound = false; initSection(el); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-produto"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      (root||document).querySelectorAll('[data-izqz]:not([data-izqz-bound])').forEach(function(q){
        q.setAttribute('data-izqz-bound','1');
        var steps   = Array.prototype.slice.call(q.querySelectorAll('[data-izqz-step]'));
        var fill    = q.querySelector('[data-izqz-fill]');
        var stepsW  = q.querySelector('[data-izqz-steps]');
        var resultsW= q.querySelector('[data-izqz-results]');
        var results = Array.prototype.slice.call(q.querySelectorAll('[data-izqz-result]'));
        var restart = q.querySelector('[data-izqz-restart]');
        var total   = steps.length;
        var cur = 0, counts = {};

        function setProgress(n){ if(fill) fill.style.width = (total ? (n/total*100) : 0) + '%'; }
        function show(i){
          steps.forEach(function(s,idx){ s.hidden = idx !== i; });
          setProgress(i);
        }
        function finish(){
          // chave mais escolhida (empate => primeira na ordem dos resultados)
          var best=null, bestN=-1;
          results.forEach(function(r){
            var k=r.getAttribute('data-key');
            var n=counts[k]||0;
            if(n>bestN){ bestN=n; best=k; }
          });
          results.forEach(function(r){ r.hidden = r.getAttribute('data-key')!==best; });
          if(stepsW) stepsW.hidden = true;
          if(resultsW) resultsW.hidden = false;
          setProgress(total);
        }
        q.querySelectorAll('[data-izqz-opt]').forEach(function(btn){
          btn.addEventListener('click', function(){
            var v = btn.getAttribute('data-value') || '';
            counts[v] = (counts[v]||0) + 1;
            cur++;
            if(cur >= total){ finish(); }
            else { show(cur); }
          });
        });
        if(restart){
          restart.addEventListener('click', function(){
            cur = 0; counts = {};
            if(resultsW) resultsW.hidden = true;
            if(stepsW) stepsW.hidden = false;
            show(0);
          });
        }
        show(0);
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ init(); });
    else init();
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-destaque"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function wire(root){
      (root||document).querySelectorAll('[data-izvd]:not([data-izvd-bound])').forEach(function(frame){
        frame.setAttribute('data-izvd-bound','1');
        var btn = frame.querySelector('[data-izvd-play]');
        if(!btn) return;
        btn.addEventListener('click', function(){
          var target = frame.querySelector('[data-izvd-target]');
          var iframe = frame.querySelector('[data-izvd-iframe]');
          var video  = frame.querySelector('[data-izvd-video]');
          if(iframe && !iframe.src){ iframe.src = iframe.getAttribute('data-src') + '&autoplay=1'; }
          if(target){ target.hidden = false; }
          btn.style.display = 'none';
          if(video){ try{ video.play(); }catch(e){} }
        });
      });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){wire();});
    else wire();
    document.addEventListener('shopify:section:load', function(e){ wire(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
